import React from "react";

function Cancellation() {
  return (
    <>
      <h1>Cancellation & Refund Policy</h1>
      <h6>Last updated on Jul 6th 2023</h6>
      <p>No cancellations & Refunds are entertained</p>
    </>
  );
}

export default Cancellation;
